import type { JSX } from 'react';
import React from 'react';
import { Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { useFlags } from '@feathr/report_components';

import FundraisePage from '../FundraisePage';
import DonationFormEditor from '../FundraisePage/DonationFormEditPage/DonationFormEditPage';
import StripeOnboardingRedirect from '../FundraisePage/StripeOnboardingRedirect';
import RouteWithPermissions from './RouteWithPermissions';

function FundraiseRoutes(): JSX.Element {
  const { showFundraise } = useFlags();

  return (
    <Switch>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/stripe/onboarding-url'}
      >
        <StripeOnboardingRedirect />
      </RouteWithPermissions>
      <RouteWithPermissions condition={showFundraise} exact={true} path={'/:accountId/fundraise'}>
        <FundraisePage />
      </RouteWithPermissions>
      {/* TODO: Add DonationFormReportPage when it is ready. */}
      {/* <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/:donationFormId'}
      >
        <DonationFormReportPage />
      </RouteWithPermissions> */}
      <Redirect
        exact={true}
        from={'/:accountId/fundraise/:donationFormId'}
        to={'/:accountId/fundraise/:donationFormId/edit'}
      />
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/:donationFormId/edit'}
      >
        <DonationFormEditor />
      </RouteWithPermissions>
    </Switch>
  );
}

export default FundraiseRoutes;
